
<app-form-input  [label]="step8.getmotclef"
	[name]="getUid() + '_SepAtt_motClef'" [parentForm]="parentForm" [disabled]="disabled"
	[type]="'chips'" [rule]="''" [value]="motsClef.motClef"
	[autoCompleteType]="'MOT_CLEF'" [autoCompleteTypeIndex]="0">
</app-form-input>

